// extracted by mini-css-extract-plugin
export default {"userSection":"styles_userSection__goOjl","username":"styles_username__RQLnc","name":"styles_name__LCqQW","logout":"styles_logout__V25ea","icon":"styles_icon__5VdBT"};